var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('PageComponent',{attrs:{"publicTemplateName":"学习未取证","publicStatus":1600}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }